import { ExternalValidationResultAlert } from "../../applications/documaker/domain/document";
import { ExternalValidationResults } from "./ExternalValidationResults";
import { RequestedObject } from "./RequestedObject";

export class ExternalSystemValidationResult extends ExternalValidationResults {
  constructor(
    public isOk: boolean,
    public message: string,
    alerts: ExternalValidationResultAlert[],
    objects: RequestedObject[],
  ) {
    super(alerts, objects);
  }
}
